<script setup lang="ts">
/**
 * FW-145 — auth yuzeyinin alt bilgi satiri: telif + Gizlilik/Koşullar/Yardım
 * (design/current/Auth v2.dc.html satir 307-310). Tasarim kaynaginda bu
 * satir TUM adimlarda (giris/parola/secim/tamam...) paylasilan ortak bir
 * kabuk parcasidir; bu bilet yalniz 01-giris-eposta'nin eksiklerini kapsadigi
 * icin (Jira FW-145 KAPSAM madde 2) o turda yalniz EmailView'a baglanmisti —
 * diger adimlarda ayni eksik SURUYORDU (bkz. FW-145 raporu "diger karelerde
 * acik kalanlar"). FW-150 bu bileseni App.vue'daki paylasilan kabuga tasidi
 * (bkz. App.vue basligi "<AuthLegalFooter>" notu); bu dosya artik hicbir
 * view'dan DOGRUDAN import edilmez.
 *
 * Hedefsiz baglanti: tasarim kaynagindaki href'lerin GERCEK degeri olculdu —
 * Gizlilik/Koşullar `href="#"` + prototip-ici `privacy` tweak'i, Yardım ise
 * `./HelpDesk.dc.html` (baska bir PROTOTIP artboard'u, gercek bir sayfa
 * degil — HelpDesk modulu BRIEF.md'de "post-MVP, Planlanma"). Yani tasarimin
 * KENDISI de gercek bir production hedefi tanimlamiyor. Var olmayan bir URL
 * UYDURMAK yerine (CLAUDE.md "yasal baglantilarin hedefleri bilinmiyorsa
 * uydurma") bu ucu <button> (gercek <a href> DEGIL, gezinme/scroll yan
 * etkisi yok) olarak, tiklaninca hicbir sey yapmayan, gorsel olarak
 * tasarimla ayni durumda render edildi. Karar Atilla'nin onayina acik
 * birakildi (bkz. FW-145 raporu).
 */
defineProps<{ copyright: string; privacy: string; terms: string; help: string }>()
</script>

<template>
  <div
    class="fw-auth-footer"
    data-testid="auth-legal-footer"
  >
    <span class="fw-auth-footer__copyright">{{ copyright }}</span>
    <div class="fw-auth-footer__links">
      <button
        type="button"
        class="fw-auth-footer__link"
        data-testid="auth-legal-footer-privacy"
      >
        {{ privacy }}
      </button>
      <button
        type="button"
        class="fw-auth-footer__link"
        data-testid="auth-legal-footer-terms"
      >
        {{ terms }}
      </button>
      <button
        type="button"
        class="fw-auth-footer__link"
        data-testid="auth-legal-footer-help"
      >
        {{ help }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.fw-auth-footer {
  margin-top: 36px;
  padding-top: 18px;
  border-top: 1px solid var(--fw-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: var(--fw-text-secondary);
}

.fw-auth-footer__links {
  display: flex;
  gap: 14px;
}

.fw-auth-footer__link {
  /* Yerlesik <button> kabugu (kenarlik/dolgu/arkaplan) SIFIRLANIR — aksi
   * halde tasarimdaki duz metin-baglanti gorunumu yerine tarayici
   * varsayilan buton cercevesi gorunur (olculdu: canli ekran goruntusu). */
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 12px;
  color: var(--fw-primary-light);
  cursor: pointer;
}
</style>
